<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M19.6882 7.44226L11.7941 2.8846L3.89999 7.44226V16.5576L11.7941 21.1153L19.6882 16.5576V7.44226ZM11.7918 10.9618L6.57091 7.97866L11.7941 4.96306L16.988 7.96178L11.7918 10.9618ZM12.6649 18.5341L12.6918 12.5207L17.8882 9.52052V15.5184L12.6649 18.5341ZM10.8918 12.5207L5.69999 9.55414L5.69999 15.5184L10.865 18.5004L10.8918 12.5207Z"
          fill="current"/>
</svg>
